import {reactive, computed, watch, onUnmounted} from 'vue';
import {router} from '@inertiajs/vue3';


interface TourStep {
    title: string;
    target: string;
    content: string;
    component: 'SidebarContentClient' | 'ClientLoggedHome';
}

const state = reactive({
    isActive: false,
    currentStepIndex: 0,
});


const tourSteps: TourStep[] = [
    {
        target: '#tour-step-1-dashboard',
        title: 'Dashboard',
        content: 'Aqui tem tudo que você precisa acompanhar: tarefas, novidades e sua evolução.',
        component: 'SidebarContentClient'
    },
    {
        target: '#tour-step-2-main-widget',
        title: 'Novidades da Rê',
        content: 'Acompanhe as novas vagas encontradas, posts prontos para você publicar no LinkedIn e materiais para te apoiar nos processos seletivos.',
        component: 'ClientLoggedHome'
    },
    {
        target: '#tour-step-3-follow-up',
        title: 'Acompanhamento semanal',
        content: 'Complete seu progresso da semana se aplicando para vagas, publicando posts prontos no LinkedIn e se conectando com as pessoas certas.',
        component: 'ClientLoggedHome'
    },
    {
        target: '#tour-step-4-sidebar',
        title: 'Onde tudo acontece',
        content: 'No menu, você acessa tudo o que a Rê pode fazer por você. É aqui que a mágica começa!',
        component: 'SidebarContentClient'
    },
    {
        target: '#tour-step-5-radar',
        title: 'Comece aqui',
        content: 'Viu uma vaga que gostou? A Rê faz seu currículo personalizado para ela, aumentando as chances de conseguir uma entrevista.',
        component: 'SidebarContentClient'
    },
];

export function useOnboarding() {
    const handleGlobalClick = (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        if (target.closest('[data-onboarding-tip="true"]')) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
    };


    const currentStep = computed(() => tourSteps[state.currentStepIndex]);
    const totalSteps = computed(() => tourSteps.length);

    const startTour = () => {
        console.log('Iniciando o tour guiado...');
        state.currentStepIndex = 0;
        state.isActive = true;
    };

    const nextStep = () => {
        if (state.currentStepIndex < tourSteps.length - 1) {
            state.currentStepIndex++;
        } else {
            finishTour();
        }
    };

    const finishTour = () => {
        console.log('Tour finalizado. Marcando como completo e redirecionando...');
        state.isActive = false;

        router.post(route('craftable-pro.onboarding.complete'));
    };

    // Função chamada ao clicar em "Explorar Sozinho"
    const skipTour = () => {
        console.log('Tour ignorado. Marcando como completo...');
        state.isActive = false;
        router.post(route('craftable-pro.onboarding.complete'), {}, {
            preserveState: true,
        });
    };

    watch(() => state.isActive, (isActive) => {
        if (isActive) {
            document.addEventListener('click', handleGlobalClick, true);
        } else {
            document.removeEventListener('click', handleGlobalClick, true);
        }
    });

    onUnmounted(() => {
        document.removeEventListener('click', handleGlobalClick, true);
    });

    return {
        isTourActive: computed(() => state.isActive),
        currentStep,
        currentStepIndex: computed(() => state.currentStepIndex),
        totalSteps,
        startTour,
        nextStep,
        finishTour,
        skipTour,
    };
}
